import { createAction } from '@reduxjs/toolkit';

export const initializeInventories = createAction('inventories/initializeInventories');
